import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  public importFromFile(bstr: string): XLSX.AOA2SheetOpts {
    /* read workbook */
    const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

    /* grab first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: XLSX.WorkSheet = wb.Sheets[wsname];

    /* save data */
    const data = <XLSX.AOA2SheetOpts>(XLSX.utils.sheet_to_json(ws, { header: 1 }));

    return data;
  }

  public exportToFile(fileName: string, element_id: string) {
    // if (!element_id) throw new Error('Element Id does not exists');
    // let tbl = document.getElementById(element_id);
    // let wb = XLSX.utils.table_to_book(tbl);
    // XLSX.writeFile(wb, fileName + '.xlsx');

    if (!element_id) throw new Error('Element Id does not exist');
  
  const originalTable = document.getElementById(element_id);
  if (!originalTable) return;

  // إنشاء نسخة من الجدول
  const tableClone = originalTable.cloneNode(true) as HTMLElement;

  // تحديد رقم العمود الذي يحتوي على "Actions"
  const actionColIndex = Array.from(tableClone.querySelectorAll('th'))
    .findIndex(th => th.textContent?.trim().toLowerCase() === 'actions');

  if (actionColIndex !== -1) {
    // حذف خلية "Actions" من كل صف
    tableClone.querySelectorAll('tr').forEach(row => {
      const cells = row.querySelectorAll('th, td');
      if (cells.length > actionColIndex) {
        cells[actionColIndex].remove();
      }
    });
  }

  // تصدير الجدول بعد حذف العمود
  const wb = XLSX.utils.table_to_book(tableClone);
  XLSX.writeFile(wb, fileName + '.xlsx');
  }
}
